<template>
  <base-page
    :title="'Admin Home Page'"
  >
    <template #main>
      <iframe width="100%" height="650" :src="getIframeLink()" frameborder="0" />
    </template>
  </base-page>
</template>
<script>
import BasePage from '@/views/BasePage.vue'

export default {
  components: {
    BasePage,
  },
  methods:{
    getIframeLink() {
      return process.env.VUE_APP_HOME_IFRAME
    }
  }
}
</script>
